import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import { hasFeatureFlags } from 'utils/features';
import { IN_PERSON_TRAINING } from 'constants/actionTypes';

export function createAttendance(attendee) {
  return (dispatch, getState) =>
    new Promise(resolve => {
      const { event, session } = getState();
      const attendanceUrl = hasFeatureFlags(['events_in_development'])
        ? routes.IN_PERSON_TRAINING.EVENT_ATTENDANCES(event.id)
        : routes.IN_PERSON_TRAINING.SESSION_ATTENDANCES(session.id);
      request
        .postJSON(attendanceUrl, {
          id: attendee.id,
          type: attendee.type,
          status: 'did_attend',
        })
        .then(res => {
          dispatch({
            type: IN_PERSON_TRAINING.ATTENDANCES.CREATE,
            attendances: res.created_attendances,
          });
          resolve();
        });
    });
}

export function removeAttendance(attendance) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { event, session } = getState();
      const attendanceUrl = hasFeatureFlags(['events_in_development'])
        ? routes.IN_PERSON_TRAINING.UPDATE_EVENT_ATTANDANCES(
            event.id,
            attendance.id,
          )
        : routes.IN_PERSON_TRAINING.SESSION_ATTENDANCE(
            session.id,
            attendance.id,
          );
      request.delete(attendanceUrl).then(res => {
        dispatch({
          type: IN_PERSON_TRAINING.ATTENDANCES.REMOVE,
          attendance,
        });
        resolve();
      });
    });
}
